import React from 'react';
import { Flex, ButtonGroup, Button } from '@chakra-ui/react';

interface ModeToggleProps {
  viewMode: 'overview' | 'aggregate';
  onOverview: () => void;
  onAggregate: () => void;
}

export const ModeToggle: React.FC<ModeToggleProps> = ({ viewMode, onOverview, onAggregate }) => (
  <Flex justify="flex-end" mb="16px">
    <ButtonGroup size="sm" isAttached>
      <Button
        colorScheme="brand"
        variant={viewMode === 'overview' ? 'solid' : 'outline'}
        onClick={onOverview}
        borderRadius="8px 0 0 8px"
      >
        Overview
      </Button>
      <Button
        colorScheme="brand"
        variant={viewMode === 'aggregate' ? 'solid' : 'outline'}
        onClick={onAggregate}
        borderRadius="0 8px 8px 0"
      >
        Aggregate
      </Button>
    </ButtonGroup>
  </Flex>
);
